import AuthMenu from "./HeadBar.Auth";

export default function HeadNav({
  title,
  name,
  designation,
  url
}: {
    title: string;
    name: string;
    designation: string;
    url: string;
})
{
  return (
    <header className="headNav d-flex position-relative w-100 align-items-center justify-content-between px-5 bg-white border-bottom">
      <div className="headNavOBR d-flex align-items-center gap-5">
        <h5 className="fw-bolder">{title}</h5>
        <nav className="d-flex gap-4">
          {['Overview', 'Batch Processing', 'Reconciliation'].map((link) => (
            <a
              key={link}
              href="#"
              style={link === 'Batch Processing' ?
                {
                  borderBottom: "2px solid #7BA9D1",
                  paddingBottom: "2px",
                } :
                {}
              }
            >
              {link}
            </a>
          ))}
        </nav>
      </div>

      <div className="d-flex align-items-center gap-4">
        <div className="position-relative">
          <i className="bi bi-search position-absolute fs-6 start-0 ms-3 top-50 translate-middle-y text-secondary"></i>
          <input
            type="text"
            placeholder="Search transactions..."
            className="ps-5 pe-3 py-2 bg-light border border-secondary-subtle rounded-pill fs-6 form-control"
            style={{ width: "24rem" }}
          />
        </div>
        <button className="text-secondary hover:bg-surface-container">
          <span className="material-symbols-outlined">notifications</span>
          <span className="position-absolute top-2 right-2 w-2 h-2 bg-red-500 border-2 border-white rounded-pill"></span>
        </button>
        <button className="text-secondary hover:bg-surface-container">
          <span className="material-symbols-outlined">help_outline</span>
        </button>
        <AuthMenu name={name} designation={designation} url={url} />
      </div>
    </header>
  );
}